import React, { useState } from 'react'
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchRecentStreamingDevices } from './service';
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import Translate from '../../../Components/MultiLanguage/Translate';

const StreamingActivity = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [RecenDevicesData,setRecentDevicesData] = useState()
  const navigate = useNavigate()
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(()=>{
    window.scroll(0,0)

    getRecentStreamingDevices()
  },[])

    const getRecentStreamingDevices = async () => {
        try{
            
            const response = await fetchRecentStreamingDevices(appInfo)
            if(response?.status === 200){
                setRecentDevicesData(response?.data?.data)
            }
        }catch(err){
            toast.error(err?.message, {
                position: "bottom-center",
              });
        }
    }
  return (
    <div className='streamingActivity'>

            <p><Translate textKey={'used_devices_location_title'}/></p>
            <ul className="recentDeviceContainer">
                {
                    RecenDevicesData?.map((item,index)=>(
                        <li key={index}>
                            <span>{item?.location}</span>
                                <span>{item?.last_used}</span>
                        </li>

                    ))
                }
            </ul>
            
    </div>
  )
}

export default StreamingActivity
